//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-227982 - Clean up mentioned_and_tagged_recommended_sorting feature flag after release
export const getHasMentionedAndTaggedRecommendedSortingFeatureEnabled =
  createHasFeatureSelector(FeatureNames.MentionedAndTaggedRecommendedSorting);
